import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class EcoDocsTitleService {
    constructor(private titleService: Title) {
    }

    setTitle(newTitle: string, append: boolean) {
     if (append){
        this.titleService.setTitle( 'EcoDocs - ' + newTitle );
     } 
     else{  
        this.titleService.setTitle(  newTitle + ' - EcoDocs' );
        }
    }

    setFavIconLink(newFaviconLink: string = 'favicon.png') {
        document.getElementById('appFavIcon').setAttribute('href', newFaviconLink);
    }
}